import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IIdentity, IPopulatedIdentity } from 'interfaces/Identity';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IListRequestParams,
} from 'interfaces/requests';
import { openAlertToUserLogoutAction } from 'modules/user';

import endpoints from './endpoints';
import { IIdentityListState } from './interfaces';

export const listIdentitiesAction = createAsyncThunk<
  IIdentity[],
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listIdentities', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const result = await get<IPopulatedIdentity[]>(MICROSERVICES.AUTH, {
      url: endpoints.listIdentities(),
      params: payload,
    });
    return result.data.map(
      (value): IIdentity => ({
        ...value,
        policies: value.policies.map((policy) => policy._id),
      }),
    );
  } catch (error) {
    dispatch(openAlertToUserLogoutAction());

    return rejectWithValue(error);
  }
});

const initialState: IIdentityListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
};

const policyListSlice = createSlice({
  name: 'policyList',
  initialState,
  reducers: {
    clearIdentityListAction: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(listIdentitiesAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.list = action.payload;
    });
    builder.addCase(listIdentitiesAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(listIdentitiesAction.rejected, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || 'Erro no servidor';
    });
  },
});

const { reducer, actions } = policyListSlice;
export const { clearIdentityListAction } = actions;
export default reducer;
